import "./MarkAsSoldDrawer.scss";

import { default as MarkAsSoldDrawer } from "./MarkAsSoldDrawer";

export default MarkAsSoldDrawer;